import { gql, TypedDocumentNode } from "@apollo/client";

import { IntentProject, QueryIntentProjectArgs } from "types/generated";

import { INTENT_PROJECT_FULL_FRAGMENT } from "../gql";

export const GET_INTENT_PROJECT: TypedDocumentNode<
  { intentProject: IntentProject },
  QueryIntentProjectArgs
> = gql`
  query GetIntentProject($id: ID!) {
    intentProject(id: $id) {
      ...IntentProjectFull
    }
  }
  ${INTENT_PROJECT_FULL_FRAGMENT}
`;
